@if (_data?.urlLink) {
  <div class="doc-viewer__container">
    <div class="image-viewer-container">
      <span class="width-100per image-viewer__close">
        <span class="flex fl-al-center mrr-20px" style="width: 95%">
          <span class="material-icons doc-viewer__close-icon" (click)="hideDocViewer()">arrow_back</span>
          <span style="font-size: 14px">{{ _data?.file.file_name }} </span>
        </span>
        <span class="material-icons mrl-20px clickable" (click)="downloadAttachment()">download</span>
      </span>
      @if (showPdfViewer) {
        <div class="image-viewer-wrapper">
          <pdf-viewer
            [src]="_data?.urlLink"
            [original-size]="false"
            (after-load-complete)="afterLoadComplete($event)"
            (error)="onError($event)"
            (on-progress)="onProgress($event)"
            style="width: 100%; height: 100vh"
          ></pdf-viewer>
        </div>
      }
      @if (showImageViewer) {
        <div class="image-viewer-wrapper">
          <img src="{{ _data?.urlLink }}" alt="" />
        </div>
      }
      <!-- show no preview -->
      @if (showNoPreview) {
        <div class="image-viewer-wrapper" style="height: 100vh !important">
          <div class="no-preview-avaialbe" style="margin: 45% auto auto auto; width: 350px">
            <p style="font-size: 19px; line-height: 27px">No preview available</p>
            <button class="download-btn" (click)="downloadAttachment()">
              <span class="material-icons">download</span>
              <span>Download</span>
            </button>
          </div>
        </div>
      }
      <!-- document loading -->
      @if (isDocumentLoading) {
        <div class="document-loading" style="height: 100vh !important">
          <p>Loading ...</p>
        </div>
      }
    </div>
  </div>
}
